import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: () => import('../views/Home.vue') },
  { path: '/features', name: 'Features', component: () => import('../views/Features.vue') },
  { path: '/pricing', name: 'Pricing', component: () => import('../views/Pricing.vue') },
  { path: '/demo', name: 'Demo', component: () => import('../views/Demo.vue') },
  { path: '/docs/:section?/:article?', name: 'Docs', component: () => import('../views/Docs.vue') },
  { path: '/contacts', name: 'Contacts', component: () => import('../views/Contacts.vue') },
  { path: '/policy', name: 'Policy', component: () => import('../views/Policy.vue') },
  { path: '/terms', name: 'Terms', component: () => import('../views/Terms.vue') },
  { path: '*', redirect: '/' },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

export default router
